import { render } from "./menu-order.vue?vue&type=template&id=78c55326"
const script = {}

import exportComponent from "D:\\Projects\\Other\\EventMaster\\Dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__